import * as React from 'react';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ReportStatus, ReportFileStatus } from './types-store';
import styles from '../my-downloads.scss';
import { PromptConfirmationModal } from 'ui/common/prompt-confirmation/prompt-confirmation-modal';
import { ElementLoader } from 'ui';
import { getFileExtension } from 'app/area/my-downloads/extensions';
import { DEFAULT_DATE_FORMAT } from 'app/infrastructure/data/date';
import { Icon } from 'ui/common/icon';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';

export interface ReportsDownloadItemProps extends ReportStatus {
  downloadReportPackage: (reportId: number, fileExtension: string) => void;
}

export type ReportsContainerProps = ReportsDownloadItemProps & DefaultContainerProps;

export class ReportsViewItem extends React.Component<ReportsContainerProps, any> {
  
  private dateFormatter = (date: string) => {
    const parsedDate = new Date(date);
    const formattedDate = this.props.intl.formatDate(parsedDate, DEFAULT_DATE_FORMAT);
    const formattedTime = this.props.intl.formatTime(parsedDate);
    return formattedDate + ' ' + formattedTime;
  };

  private onDownload = () => {
    const { reportFileId, contentType } = this.props;
    this.props.downloadReportPackage(reportFileId, getFileExtension(contentType));
  };

  public render() {

    const { reportFileId, download, createdDate, status, description, contentType, translation,
      emailReceivers, companyReport, favourite, scheduled} = this.props;
    const isPending = status && (status.v <= [ReportFileStatus.pending]);
    const fileExtension = getFileExtension(contentType);

    const iconAbsolutePath = toAbsoluteUrl('i/recurrenceMyDownloads.svg');
    const iconSchedule = <Icon url={iconAbsolutePath} />;

    const buttonBody = <>
      {!!isPending && <div className={styles.progress}><div className={styles.progressBar} /></div>}

      <div className={styles.myDownloadsTileExtWrapper}>
        <div className={styles.fileExtention}>{fileExtension ? '.' + fileExtension : ''}</div>
      </div>
      <div className={styles.myDownloadsDownloadContent}>
        <h2 className={styles.myDownloadsDownloadItemTitle}>
          {description && description.d}
          {scheduled && <span className={styles.iconSchedule}>{iconSchedule}</span>}
          <div className={styles.companyReportTitle}>{companyReport?.d}</div>
        </h2>
        <h2 className={styles.myDownloadsDownloadItemReportTitle}>
          {favourite?.d}
        </h2>        
        {emailReceivers && 
          <ul className={styles.myDownloadsDownloadData}>
            <li>{translation.report_sent_to}{': '}</li>
            <li className={styles.emailReceiversValue}>{emailReceivers}</li>          
          </ul>}
          <ul className={styles.myDownloadsDownloadMetadata}>
            <li>{status && status.d}</li>
            <li>
              {this.dateFormatter(createdDate).trim()}
            </li>
          </ul>
      </div>
    </>;

    const button = <button
      type="button"
      className={styles.myDownloadsDownloadItem}>
      <div className={styles.downloadItemBody}>
        {download && reportFileId && download.reportId === reportFileId && download.fetching
          ? <ElementLoader /> : buttonBody}
      </div>
    </button>;

    return status && status.v === ReportFileStatus.finished ? <PromptConfirmationModal
      title={translation.report_download_title}
      description={translation.report_download_description}
      continueText={translation.report_download_submit}
      cancelText={translation.report_download_cancel}
      onContinue={this.onDownload}>
      {button}
    </PromptConfirmationModal> : button;
  }
}
